<template>
  <div class="grid-table">
    <DataTable
        class="elevation-0 w-100 grid-styles"
        loading-text="Загрузка данных..."
        no-data-text="Нет данных"
        v-bind.sync="tableModel.bind"
        v-on="tableModel.on"
        :page.sync="tableModel.bind.options.page"
    >
      <template #bottom></template>
      <template v-slot:item="{ item }">
        <tr>
          <template v-for="(header, index) in tableModel.bind.headers.filter(header => !!header.key)" :key="index">
            <td :class="'column' + (index + 1)">
              <eventStatus
                v-if="header.key.match(/success/)"
                :isSuccess="item.event.success"
                :value="item.event.success ? 'Успешно' : 'Ошибка'"
              />
              <span v-else>{{ getNestedValue(item, header.key) }}</span>
            </td>
          </template>
          <td :class="'column' + (tableModel.bind.headers.length + 1)">
            <v-menu
              transition="slide-x-transition"
              location="bottom left"
            >
              <template v-slot:activator="{ props }">
                <v-btn
                  variant="text"
                  v-bind="props"
                  icon="mdi-eye-outline"
                >
                  <v-icon size="24">custom:downloadFilesIcon</v-icon>
                </v-btn>
              </template>
              <div class="detailsActions">
                <v-list-item
                  class="detailsAction intec-blue--text"
                  :disabled="!item.requestFile.id"
                  @click="onGetDetails(item.requestFile.id)"
                >{{ $t('Скачать запрос') }}</v-list-item>
                <v-list-item
                  class="detailsAction intec-blue--text"
                  :disabled="!item.responseFile.id"
                  @click="onGetDetails(item.responseFile.id)"
                >{{ $t('Скачать ответ') }}</v-list-item>
              </div>
            </v-menu>
          </td>
        </tr>
      </template>
    </DataTable>
    <Pagination
      :table-model="tableModel"
      :page-sizes-list="pageSizesList"
    />
  </div>
</template>

<script>
import {ref} from 'vue';
import eventStatus from "../../../components/eventStatus.vue";
import Pagination from '@/components/Pagination.vue';
import DataTable from '@intec/vue-components/table/DataTable.vue'

export default {
  name: 'ApiEventsGrid',
  components: {Pagination, eventStatus, DataTable},
  props: {
    tableModel: {
      type: Object,
      required: true,
    },
    pageSizesList: {
      type: Object,
    },
    onGetDetails: {
      type: Function,
    },
  },
  setup() {
    const isHovered = ref(false);

    return {
      isHovered,
    };
  },
  methods: {
    getNestedValue(obj, path) {
      return path.split('.').reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : ''), obj);
    },
  },
};
</script>

<style scoped>
.header-icon {
  color: rgb(var(--data-table-font-header-color));
  opacity: 0.5;
}

.grid-table {
  font-family: 'Manrope';
  font-size: 16px;
  font-style: normal;
  line-height: 24px;
  padding: 19px 0 0 0;
}


:deep(.v-data-table__th) {
  background-color: rgb(var(--data-table-header-color));
  color: rgb(var(--data-table-font-header-color)) !important;
}

:deep(.v-data-table__td:nth-child(3), th:nth-child(3)) {
  color: rgb(var(--data-table-font-color));
}

tr {
  background-color: rgb(var(--white-color));
}

:deep(table) {
  border-spacing: 0 1px !important;
}

:deep(.v-btn) {
  height: 24px;
  width: 24px;
}

.detailsActions {
  align-items: flex-start;
  background: rgb(var(--white-color));
  border-radius: 6px;
  box-shadow: 0px 1px 4px 0px rgba(var(--black-color), 0.4);
  display: inline-flex;
  flex-direction: column;
  padding: 5px 10px;

  .detailsAction {
    align-items: center;
    cursor: pointer;
    display: flex;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    gap: 10px;
    line-height: normal;
    padding: 0;
    width: 100%;
  }

  .detailsAction:hover {
    background-color: #f5f5f5 !important;
  }
}

:deep(.searchButtons .buttons) {
  justify-content: left;
}
</style>
